// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__A_kFp"};